<template>
  <component :is="wrapperTag" :href="link">
    <img
      :src="src"
      :alt="alt"
      :width="width"
      :height="height"
      :class="classes"
      :style="style"
    />
  </component>
</template>

<script>
import './vue-image.scss';

export default {
  name: 'VueImage',
  props: {
    alt: {
      type: String,
      required: true,
      default: ''
    },
    height: {
      type: String,
      required: false
    },
    width: {
      type: String,
      required: false
    },
    fullWidth: {
      type: Boolean,
      default: false,
      required: false
    },
    fullHeight: {
      type: Boolean,
      default: false,
      required: false
    },
    link: {
      type: String,
      default: null,
      required: false
    },
    src: {
      type: String,
      required: true,
    },
    objectFit: {
      type: String,
      required: false
    },
    extraClasses: {
      type: Object,
      required: false
    },
  },
  computed: {
    wrapperTag() {
      return this.link ? "a" : "div"
    },
    classes() {
      return {
        [`tw-w-full`]: this.fullWidth,
        [`tw-h-full`]: this.fullHeight,
        ...this.extraClasses
      };
    },
    style() {
      return {
        objectFit: this.objectFit,
        height: this.height
      };
    },
  }
};
</script>
